import React, { FC, ReactNode } from 'react';

import { KeycloakInstanceContext } from 'containers/App/keycloak/context';
import { useKeyCloak } from 'containers/App/keycloak/useKeyCloak';

interface IKeycloakContextProps {
  children?: ReactNode;
}

export const KeycloakContext: FC<IKeycloakContextProps> = props => {
  const { children } = props;
  // Expose MFA actions through the shared authenticated Keycloak context.
  const {
    keycloak,
    logOut,
    resetPassword,
    forceRefreshToken,
    configureTwoFactor,
    reauthenticateForMFA,
  } = useKeyCloak();

  return (
    <KeycloakInstanceContext.Provider
      value={{
        keycloak,
        logOut,
        resetPassword,
        forceRefreshToken,
        configureTwoFactor,
        reauthenticateForMFA,
      }}
    >
      {children}
    </KeycloakInstanceContext.Provider>
  );
};
